// extracted by mini-css-extract-plugin
export default {"container":"InputControl_container__mfENv"};